import styled from "@emotion/styled"
import { Box, Flex } from "@chakra-ui/react"

export const StyledBox = styled(Box)`
  &:hover {
    svg {
      fill: var(--chakra-colors-white);
    }

    h2 {
      color: white;
    }
    .chakra-badge {
      background: white;
      color: black;
    }
  }
`
export const StyledFlex = styled(Flex)`
  .outlined-text {
    visibility: hidden;
    opacity: 0;
    margin-top: 5px;
    line-height: 11px;
    font-size: 12px;
  }
  &:hover {
    .outlined-text {
      visibility: visible;
      opacity: 1;
      transition: 0.3s ease;
    }
  }
`
